 export const texts = {

  en: {
    message: {
      about: 'about padmin',
      active_users: 'active users in last {mins} mins',
      agung_runtime_errors: 'PassMan runtime errors',
      agung_runtime_errors_count: 'occurences',
      agung_runtime_errors_first_occ_datetime: 'first occurence datetime',
      agung_runtime_errors_none: 'none',
      auth_conf_default_provider: 'default provider',
      auth_conf_new_ad: 'active-directory',
      auth_conf_new_atl_crowd: 'atlassian crowd',
      auth_conf_new_azure_ad: 'azure AD',
      auth_conf_new_jira_oauth2: 'Jira OAuth2',
      auth_conf_new_open_ldap: 'Open LDAP',
      auth_conf_new_oracle: 'Oracle IDCS',
      auth_conf_new_saml2: 'saml2',
      auth_conf_passman_url: 'PassMan URL',
      auth_conf_provider_ad_doc_label: 'How to configure AD for passman',
      auth_conf_provider_ad_doc_link: 'https://wiki.passman.co/latest/en/administrator-s-guide/padmin-system-administration/system-settings/authentication-provider-settings/windows-ad-provider',
      auth_conf_provider_app_token: 'app_token',
      auth_conf_provider_azure_doc_label: 'How to configure azure AD for passman',
      auth_conf_provider_azure_doc_link: 'https://wiki.passman.co/latest/en/administrator-s-guide/padmin-system-administration/system-settings/authentication-provider-settings/azure-ad-provider',
      auth_conf_provider_base_dn: 'base DN',
      auth_conf_provider_base_dn_placeholder: 'format: dc=demopassmanad,dc=local',
      auth_conf_provider_base_dn_warning: 'The first character cannot be, and the last character can be only in special cases quotation mark',
      auth_conf_provider_base_url: 'base URL',
      auth_conf_provider_certificate: 'certificate',
      auth_conf_provider_client_id: 'client ID',
      auth_conf_provider_credential: 'credential',
      auth_conf_provider_error_missing_param: 'Missing {param_name} parameter on {prov_name} provider!',
      auth_conf_provider_groups_all: 'all',
      auth_conf_provider_groups_none: 'none',
      auth_conf_provider_group_member_attr: 'group member attribute',
      auth_conf_provider_group_object_class: 'group object class',
      auth_conf_provider_is_sso: 'SSO like login',
      auth_conf_provider_is_sso_desc: 'Automatic login to PassMan if there is Azure AD logged user',
      auth_conf_provider_jira_doc_label: 'How to configure jira for passman',
      auth_conf_provider_jira_doc_link: 'https://wiki.passman.co/latest/en/administrator-s-guide/padmin-system-administration/system-settings/authentication-provider-settings/jira-provider',
      auth_conf_provider_name: 'name',
      auth_conf_provider_open_ldap_doc_label: 'How to configure Open LDAP for passman',
      auth_conf_provider_open_ldap_doc_link: 'https://wiki.passman.co/latest/en/administrator-s-guide/padmin-system-administration/system-settings/authentication-provider-settings/open-ldap',
      auth_conf_provider_context: 'context',
      auth_conf_provider_port: 'port',
      auth_conf_provider_context: 'context',
      auth_conf_provider_port: 'port',
      auth_conf_provider_token_expiry_hours: 'login expiry',
      auth_conf_provider_redirect_uri: 'redirect URI',
      auth_conf_provider_required_groups: 'authentication groups',
      auth_conf_provider_saml_auth: 'use SAML auth',
      auth_conf_provider_saml_claims_email: 'email SAML attribute name',
      auth_conf_provider_saml_claims_first_name: 'first name SAML attribute name',
      auth_conf_provider_saml_claims_groups: 'groups SAML attribute name',
      auth_conf_provider_saml_claims_last_name: 'last name SAML attribute name',
      auth_conf_provider_saml_claims_upn: 'UPN SAML attribute name',
      auth_conf_provider_saml_doc_label: 'How to configure azure saml2 for passman',
      auth_conf_provider_saml_doc_link: 'https://wiki.passman.co/latest/en/administrator-s-guide/padmin-system-administration/system-settings/authentication-provider-settings/saml2-provider',
      auth_conf_provider_saml_entity_id: 'Identity Provider Entity ID',
      auth_conf_provider_saml_lp_x509cert: 'IdP Signature certificate',
      auth_conf_provider_saml_slo: 'SSO Logout URL',
      auth_conf_provider_saml_sp_private_key: 'SP Encryption private key',
      auth_conf_provider_saml_sp_x509cert: 'SP Encryption certificate',
      auth_conf_provider_saml_sso: 'SSO Login URL',
      auth_conf_provider_servers: 'servers',
      auth_conf_provider_tech_user: 'tech user',
      auth_conf_provider_tech_user_password: 'tech user password',
      auth_conf_provider_tech_user_username: 'tech user username',
      auth_conf_provider_tenant_name: 'tenant',
      auth_conf_provider_tooltip: 'You can reach the tutorial by clicking the link',
      auth_conf_provider_used_groups: 'permission groups',
      auth_conf_provider_username_field: 'username field',
      auth_conf_provider_valid_names: 'valid names',
      auth_conf_provider_visible_ous: 'only visible OU-s',
      auth_conf_provider_visible_ous_placeholder: 'format: SouthAmerica/Sales/Servers',
      auth_conf_token_expiry: 'login expiry time',
      auth_conf_token_expiry_forced: 'forced',
      auth_conf_token_expiry_forced_desc: 'If this parameter is enabled, users cannot individually change the login expiry time (token expiration). The time specified here is set for all users.',
      autocomplete_after_loading_ous: 'autocomplete after loading OU-s',
      autorefresh_is_off: 'autorefresh is off',
      autorefresh_is_on: 'autorefresh is on',
      business_result_Failed: 'failed',
      business_result_InProgress: 'in progress',
      business_result_InUpload: 'in upload',
      business_result_Success: 'success',
      button_backup: 'backup',
      button_cancel: 'cancel',
      button_check: 'check',
      button_confirm: 'confirm',
      button_copy: 'copy',
      button_close: 'close',
      button_connect: 'connect',
      button_copy_to_clipboard: 'copy to clipboard',
      button_delete: 'delete',
      button_delete_multifactor_shared_secret: 'delete otp code, user will receive new code when login',
      button_disable: 'disable',
      button_disconnect: 'disconnect',
      button_download: 'download',
      button_edit: 'edit',
      button_enable: 'enable',
      button_existing_cluster: 'existing cluster',
      button_export: 'export',
      button_import: 'import',
      button_initialize: 'initialize',
      button_load_group_names: 'load groups',
      button_load_ou_names: 'load OU-s',
      button_login: 'login',
      button_move_down: 'move down',
      button_move_up: 'move up',
      button_new: 'new',
      button_new_cluster: 'new cluster',
      button_next: 'next',
      button_notify: 'notify',
      button_padmin_restart: 'restart padmin',
      button_passman_restart: 'restart passman',
      button_reboot: 'reboot',
      button_refresh: 'refresh',
      button_reload: 'page reload',
      button_reset_password_email: 'reset password email',
      button_restart: 'restart',
      button_restore: 'restore',
      button_run: 'run',
      button_save: 'save',
      button_send: 'send',
      button_show_cluster: 'show cluster',
      button_show_multifactor_shared_secret_dialog: 'show otp shared secret',
      button_show_output: 'show output',
      button_shutdown: 'shutdown',
      button_status: 'status',
      button_unstuck: 'unstuck',
      button_update: 'update',
      button_upload: 'upload',
      button_verify: 'verify',
      button_yes: 'yes',
      change_password: 'change password',
      change_password_cluster_sys: 'You have to change password on each cluster node separately!',
      change_password_success: 'password changed successfully',
      update_provider_status: 'update provider users / groups',
      cluster_node_status_false: 'down',
      cluster_node_status_true: 'up',
      cluster_remote_login_port: 'cluster remote login port',
      cluster_status: 'cluster status',
      cluster_status_alive_3: 'ok',
      cluster_status_alive_2: 'ok',
      cluster_status_alive_1: 'not ok',
      cluster_status_alive_0: 'not ok',
      comment: 'comment',
      comp_needs_update: 'needs update!',
      confirmation_text: 'Are you sure?',
      confirmation_title: 'Confirmation needed',
      conflict: 'Conflict',
      conflict_message: "User {user} is executing {action} action right now, you have to wait until it is finished.",
      conflict_same_user_message: "Your {action} action has not been finished yet. If you suspect to be stucked, you can unstuck it on the Logs/Padmin Audit log page.",
      current_password: 'Current password',
      dashboard: 'dashboard',
      data_import_export_auto_enabled: 'auto backup enabled',
      data_import_export_auto_interval_type: 'interval',
      data_import_export_auto_interval_type_daily: 'daily',
      data_import_export_auto_interval_type_every_x_minutes: 'every x minutes',
      data_import_export_daily_at_time: 'daily at this time',
      data_import_export_decrypt_password: 'decrypt password',
      data_import_export_encrypt_password: 'encrypt password',
      data_import_export_every_x_minutes_begin: 'every',
      data_import_export_every_x_minutes_end: 'minutes',
      data_import_export_export_destination: 'export destination',
      data_import_export_export_destination_cifs: 'server via cifs',
      data_import_export_export_destination_cifs_domain: 'domain',
      data_import_export_export_destination_cifs_password: 'password',
      data_import_export_export_destination_cifs_smb_server: 'smb server',
      data_import_export_export_destination_cifs_smb_share: 'smb share',
      data_import_export_export_destination_cifs_username: 'username',
      data_import_export_export_destination_none: 'none',
      data_import_export_export_destination_scp: 'server via scp',
      data_import_export_export_destination_scp_auth_method: 'auth method',
      data_import_export_export_destination_scp_directory_path: 'directory path',
      data_import_export_export_destination_scp_password: 'password',
      data_import_export_export_destination_scp_private_key: 'private key',
      data_import_export_export_destination_scp_server: 'server',
      data_import_export_export_destination_scp_server_port: 'port',
      data_import_export_export_destination_scp_username: 'username',
      data_import_export_export_sm_data: 'export session management data',
      data_import_export_export_sm_data_desc: "Only when export destination set, due to large storage requirements",
      data_import_export_import_params: 'import parameters',
      data_import_export_import_param_db_file: 'database backup file',
      data_import_export_import_param_sm_control_file: 'session management control file',
      data_import_export_import_param_sm_data_file: 'session management data file',
      data_import_export_import_param_system_config_file: 'system config file',
      data_import_export_import_source: 'import source',
      data_import_export_keep_for_days: 'keep locally for',
      database_primary: 'database primary node',
      database_replica_set_status: 'database replica set status',
      database_running: 'database running',
      database_running_local: 'local database running',
      days: 'days',
      db_state: 'db state',
      db_state_readonly: 'read only',
      db_state_readonly_pending: 'read only pending',
      db_state_writeable: 'writeable',
      disk_space_monitoring_estimated_warning: 'With current trends free disk space is estimated to reach warning level in {days} days',
      disk_space_monitoring_warn_email: 'send warning to email address',
      disk_space_monitoring_warning_used_percent: 'warning used percent',
      duplicated: 'duplicated',
      downloading: 'downloading',
      edit_after_loading_groups: 'edit after loading groups',
      edit_license: 'change license',
      edit_providers: 'view, edit providers',
      edit_sm: 'view, edit details',
      edit_sm_storage: 'expand volume size',
      email_body: 'body',
      email_default_sender: 'default sender',
      email_expiry_notifications: 'expiry notifications',
      email_passman_link_url: 'PassMan link URL',
      email_password: 'password',
      email_recipient: 'recipient',
      email_sent_failure: 'Email sending failed',
      email_sent_success: 'Email sent successfully',
      email_send_test: 'test',
      email_server: 'mail server',
      email_status: 'email status',
      email_status_configured: 'configured',
      email_status_last_email_sent_time: 'last email sent',
      email_status_last_email_sent_time_none: 'none',
      email_status_not_configured: 'not configured',
      email_server_port: 'mail server port',
      email_status_unsent_email_count: 'unsent email count',
      email_subject: 'subject',
      email_username: 'username',
      email_use_tls: 'use TLS',
      error_agung_already_readonly: 'Already read only!',
      error_agung_already_writeable: 'Already writeable!',
      error_agung_could_not_set_to_readonly_pending: 'Could not set to readonly pending!',
      error_agung_probably_not_running: 'PassMan probably not running!',
      error_auth_failed: 'Authentication failed!',
      error_bad_gateway: 'Bad Gateway, HTTP 502',
      error_cluster_duplicate: 'Cluster has duplicate address!',
      error_cluster_not_on_same_subnet: 'Cluster not on same subnet!',
      error_cluster_this_ip_not_included: 'IP of this computer must be included in the cluster nodes!',
      error_could_not_validate_fqdn: 'Could not validate fqdn: {details}. Would you save it anyway?',
      error_forbidden_char_in_param: 'Invalid character in parameter!',
      error_init_already_initialized: 'Already initialized!',
      error_init_cluster_already_set: 'Cluster already set!',
      error_init_doublequote_in_params: 'Doublequote in params!',
      error_init_invalid_cluster_options: 'Invalid cluster options!',
      error_init_license_not_set: 'License not set!',
      error_init_missing_hostname: 'Missing hostname!',
      error_init_node_not_responding: 'Node not responding!',
      error_init_port_not_supported: 'Not supported port! Must be 22 or over 1023!',
      error_invalid_country_code: 'Invalid country code!',
      error_invalid_directory_path: 'Invalid directory path!',
      error_invalid_domainname: 'Invalid domain name!',
      error_invalid_domain_pattern: 'Invalid domain pattern!',
      error_invalid_email: 'Invalid email!',
      error_invalid_filename_postfix: 'Invalid filename postfix! Only alphanumeric chars allowed!',
      error_invalid_file_format: 'Invalid file format (or file name)!',
      error_invalid_fqdn: 'Invalid fqdn, {details}!',
      error_invalid_fqdn_port: 'Invalid fqdn:port, {details}!',
      error_invalid_hostname: 'Invalid hostname!',
      error_invalid_ip: 'Invalid IP address!',
      error_invalid_name: 'Invalid rule name! Only alphanumeric chars and space are allowed!',
      error_invalid_netmask: 'Invalid netmask (must be between 0 and 32)!',
      error_invalid_port: 'Invalid port!',
      error_invalid_providername: 'Invalid provider name (only lowercase alphanumeric chars allowed)!',
      error_invalid_psk: 'Invalid psk (only alphanumeric chars allowed)!',
      error_invalid_servername: 'Invalid server name!',
      error_invalid_tech_user: 'Invalid tech user!',
      error_invalid_tenantname: 'Invalid tenant name!',
      error_invalid_time: 'Invalid time!',
      error_invalid_url: 'Invalid url!',
      error_invalid_username: 'Invalid username!',
      error_ip_change_in_cluster_not_supported: 'IP change not supported in cluster mode!',
      error_license_cloud_in_single: 'Cloud license not accepted in single mode!',
      error_license_expired: 'License expired!',
      error_license_invalid: 'Invalid license!',
      error_license_not_cloud: 'License not for cloud',
      error_license_not_ha: 'HA license needed for cluster mode!',
      error_license_not_passman: 'License not for Passman!',
      error_license_set_later: 'Please set license later!',
      error_license_update_period_expired: 'Update not allowed, because software update period of license has expired or license is invalid!',
      error_empty_license: 'Empty license!',
      error_missing: 'Missing',
      error_not_enough_disk_space: 'Not enough free disk space! You still need: ',
      error_os_update_extract: 'Could not extract OS update file',
      error_os_update_not_allowed: 'OS update not allowed in this state! Please start again the from a new image and run OS update right after network settings have been set!',
      error_password_must_contain_lowercase_letter: 'must contain lowercase letter',
      error_password_must_contain_number: 'must contain number',
      error_password_must_contain_special_char: 'must contain special character',
      error_password_must_contain_uppercase_letter: 'must contain uppercase letter',
      error_password_too_short: 'must be at least 12 characters long',
      error_password_weak: 'Password is not strong enough',
      error_passwords_dont_match: "Passwords don't match!",
      error_static_route_not_same_subnet: 'Static route is not on same subnet!',
      error_swap_no_change: 'No change',
      error_timeout_restart_agung_remark: 'Command takes longer then expected for some reason. Please wait a few minutes, and then restart passman!',
      error_timeout_restart_padmin_remark: 'Command takes longer then expected for some reason. Please wait a few minutes, and then restart padmin!',
      error_too_many_login_attempts: 'Too many login attempts, please try again later!',
      error_username_empty: 'Empty username!',
      error_update_not_allowed_before_network_set: 'Update not possible before setting network config!',
      error_vpn_enable_autoconnect_in_connected_state_only: 'Autoconnect can be turned on in connected state only',
      external: 'external',
      filename: 'filename',
      file_upload_browse_button: 'Browse',
      file_upload_placeholder: 'Choose a file...',
      forbidden: 'Forbidden',
      forbidden_message: 'You dont have the permission to access this funcionality.',
      force_save: 'force save',
      forgot_password: 'Forgot password',
      hostname: "hostname",
      hours: 'hours',
      info_debug_mode_enabled: 'Debug mode enabled',
      info_debug_mode_disabled: 'Debug mode disabled',
      info_mongo_explain_disabled: 'Mongo explain disabled',
      info_mongo_explain_enabled: 'Mongo explain enabled',
      init_agung: 'database initialize',
      init_agung_email: 'email',
      init_agung_error_invalid_email: 'invalid email address',
      init_agung_error_min_length_16: 'lenght must be at least 16 characters',
      init_agung_first_name: 'first name',
      init_agung_last_name: 'last name',
      init_agung_generate: 'generate initial parameters',
      init_agung_password: 'local user password',
      init_agung_username: 'local username',
      init_agung_vault_password: 'vault user password',
      init_agung_vault_username: 'vault username',
      init_agung_passwords_warning: "The vault and admin passwords are shown only now, you'd better note it down.",
      init_cluster_info: 'You have to install nodes in this order, with the first node being this one!',
      init_join_cluster_node_ip: 'healthy cluster node IP',
      init_cluster_nodes: 'cluster nodes',
      init_cluster_warning: 'You have to set all nodes of a cluster before initializing the database',
      init_hint_license_first: 'You have to set license first',
      init_hint_network_first: 'You have to set network first',
      init_hint_mode_first: 'You have to set mode first',
      init_mode: 'mode',
      init_node_ip: 'node IP',
      init_mode_new_cluster_warning: 'Please check your cluster settings, after save you can no longer change them.',
      init_procedure: 'initialization procedure',
      init_state: 'initialization state',
      init_success: 'initialization succeeded',
      instance_state: 'cloud instance state',
      ip_address: 'IP address',
      ip_change_redirect_title: 'Redirecting to new IP',
      ip_change_redirect_desc: 'You are going to be redirected to the new IP address.',
      language: 'language',
      language_de: 'german',
      language_en: 'english',
      language_hu: 'hungarian',
      last_boot_time: 'last boot time',
      last_db_dump_time: 'last database backup time',
      last_db_dump_time_none: 'none',
      last_login_time: 'last login',
      last_open_time: 'last open',
      last_refresh: 'last refresh',
      last_update: 'last update',
      last_update_details: 'details',
      last_update_params: 'with parameters',
      last_update_system_time: 'system time',
      license_account_count: 'accounts',
      license_company: 'subscriber',
      license_current: 'current license',
      license_expiry: 'license expiry',
      license_user_count: 'users',
      license_new: 'new license',
      license_new_file: 'new license file',
      license_session_management_active_session_count: 'active sessions',
      license_session_management_session_count: 'sessions',
      license_session_management_support: 'session management',
      license_software_update_till: 'software update till',
      license_status: 'license status',
      license_status_expired: 'expired',
      license_status_invalid: 'invalid',
      license_status_valid: 'valid',
      license_target_count: 'targets',
      load_balancer_used: 'load balancer used',
      load_balancer_fqdn: 'load balancer fqdn',
      local: 'local',
      login: 'login',
      logout: 'logout',
      minutes: 'min(s)',
      multifactor_qr_text: "You need to sync the QR code (or the key) in an Auth.app on your smart device. If you skip this action you WON'T BE ABLE TO LOGIN TO PADMIN",
      network: 'network addresses',
      network_dns: 'dns',
      network_gateway: 'gateway',
      network_netmask: 'netmask',
      network_search_domains: 'search domains',
      network_search_domains_info: 'recommended to set in case of local dns',
      network_static_route_metric: 'metric',
      network_static_route_to: 'to',
      network_static_route_via: 'via',
      network_static_ip: 'static IP',
      no_change: '**********',
      none_or_no_change: '**********',
      new_password: 'new password',
      new_password_again: 'new password again',
      notified_count: 'Notified {notified_count} users',
      notify_failed_count: 'Failed to notify {failed_count} users',
      notify_failure: 'Failed to notify any users',
      notify_success: 'Active users notified',
      open_vault: 'open vault',
      optional: 'optional',
      os_update: 'OS update',
      output: 'Output',
      page_reload_title: 'Reload page',
      page_reload_desc: 'You have to reload the page after a few seconds for the changes to take effect',
      page_reload_reboot_title: 'Reload page after few minutes',
      page_reload_reboot_desc: "You have to reload the page for the changes to take effect. Reboot may take a few minutes, there won't be any response till that.",
      padmin_restart_required: 'padmin restart required',
      padmin_and_passman_restart_required: 'padmin and passman restart required',
      passman_accessible: 'PassMan accessible',
      passman_restart_required: 'PassMan restart required',
      passman_running: 'PassMan running',
      passman_running_local: 'local passman running',
      passman_status: 'PassMan status',
      password: 'password',
      password_changed: 'Password has successfully changed.',
      password_changed_on_this_node_only: 'Password successfully changed on this node only.',
      password_changed_on_all_nodes: 'Password successfully changed on all nodes.',
      password_expired_message: 'Your password has been expired, you have to change it.',
      passwords_dont_match: "Passwords don't match.",
      pmsl_command_demo: "PMSL command demo",
      pmsl_command_demo_account_name: "account name",
      pmsl_command_demo_check: "check",
      pmsl_command_demo_client: "client",
      pmsl_command_demo_command: "command",
      pmsl_command_demo_credential_type: "credential type",
      pmsl_command_demo_explicit_localhost: "explicit localhost",
      pmsl_command_demo_gateway_auth_enabled: "gateway auth enabled",
      pmsl_command_demo_network_level_auth: "network level authentication",
      pmsl_command_demo_send_gateway_token: "send gateway token (use token)",
      pmsl_command_demo_target_name: "target name",
      pmsl_command_demo_target_type: "target type",
      pmsl_command_demo_through_gateway: "through gateway (proxy)",
      pmsl_command_demo_use_scb: "use scb",
      provider_check_error: "Couldn't connect to provider",
      provider_check_success: 'Successfully connected to provider!',
      provider_check_invalid_groups: 'These groups seem invalid',
      pwd_info_title: 'The new password',
      pwd_info_line1: 'Must be at least 8 characters long',
      pwd_info_line2: 'Must contain lowercase and uppercase characters',
      pwd_info_line3: 'Must contain digit and special character',
      pwd_info_line4: 'Maximum length of monotonic character sequences is 3',
      pwd_info_line5: '5 characters in the new password must not be present in the old password',
      pwd_info_line6: 'Cannot contain the username',
      proc: 'processes',
      reboot_text: 'server is rebooting, it may take a while, please refresh the page after a few minutes',
      reboot_local_title: 'Reboot local server',
      reboot_local_desc: 'You have to reboot the local server to finish initialization',
      remote_login_port: 'remote login port',
      required: 'required',
      request_address: 'Your IP address',
      request_route: 'On route',
      reset_password_email_info: 'Email with instructions how to reset password has been sent (if username exists and has an email address given)',
      result_failure: 'failure',
      result_in_progress: 'running',
      result_success: 'success',
      run_auto_backup_test: 'test run',
      running_task_count: 'running task count',
      script_certificate: 'certificate',
      script_certificate_generate_self_signed_cert: 'generate self signed certificate',
      script_certificate_cert_request: 'certificate request',
      script_certificate_upload_cert: 'upload certificate',
      script_config: 'system settings',
      script_config_authentication: 'authentication',
      script_config_authentication_doc_link: ' https://wiki.passman.co/latest/en/administrator-s-guide/padmin-system-administration/system-settings/authentication-provider-settings',
      script_config_authentication_short: 'auth',
      script_config_auto_jobs: 'auto jobs',
      script_config_auto_jobs_desc: 'PassMan runs jobs daily in the background. You can specify at which hour these jobs shall run, preferably at night, when less users use the system. It is advised to keep the same timely order. First accounts shall be checked, then the ones expiring soon shall be reset, then the ones exiring later shall be notified about by email.',
      script_config_auto_jobs_doc_link: 'https://wiki.passman.co/latest/en/administrator-s-guide/padmin-system-administration/system-settings/auto-jobs',
      script_config_email: 'email account settings',
      script_config_email_doc_link: 'https://wiki.passman.co/latest/en/administrator-s-guide/padmin-system-administration/system-settings/email-account-settings',
      script_config_extend_volume: 'Volume size expanding',
      script_config_extend_volume_desc: 'You have to expand disc volume in virtualization layer (vmware, hyper-v, proxmox) first!',
      script_config_extend_volume_doc_link: 'https://wiki.passman.co/latest/en/administrator-s-guide/padmin-system-administration/system-settings/volume-size-expanding',
      script_config_license: 'license',
      script_config_network: 'network settings',
      script_config_network_doc_link: 'https://wiki.passman.co/latest/en/administrator-s-guide/padmin-system-administration/system-settings/network-settings',
      script_config_nginx_file_upload_size: 'Max. file upload size',
      script_config_passman_service: 'passman service',
      script_config_pmsl: 'PMSL settings',
      script_config_pmsl_desc: 'These settings influence how the pmsl tool tries to connect to the given target initiated from passman (one click). Explicit localhost: adds .\ to the front of target name.',
      script_config_push_notification: 'push notification',
      script_config_secret: 'secret',
      script_config_session_management: 'Session management',
      script_config_session_management_doc_link: 'https://wiki.passman.co/latest/en/administrator-s-guide/padmin-system-administration/system-settings/session-management-settings',
      script_config_supported_languages: 'supported languages',
      script_config_swap: 'swap',
      script_config_syslog_server: 'syslog server',
      script_config_time: 'time and NTP servers',
      script_config_time_doc_link: 'https://wiki.passman.co/latest/en/administrator-s-guide/padmin-system-administration/system-settings/time-and-ntp-servers',
      script_config_user_management: 'user management',
      script_config_vpn_connection: 'VPN connection',
      script_config_vpn_connection_doc_link: 'https://wiki.passman.co/latest/en/administrator-s-guide/padmin-system-administration/system-settings/vpn-connection',
      script_config_vpn_connection_autoconnect: 'autoconnect',
      script_config_vpn_connection_password: 'password',
      script_config_vpn_connection_vpn_profile: 'VPN profile',
      script_config_vpn_connection_type: 'type',
      script_config_vpn_connection_username: 'username',
      script_config_workflow: 'workflow module',
      script_config_zabbix: 'Zabbix',
      script_data: 'data backup/restore',
      script_data_config_download: 'download system settings',
      script_data_config_download_doc_link: 'https://wiki.passman.co/latest/en/administrator-s-guide/padmin-system-administration/data-backup-restore',
      script_data_config_upload: 'upload system settings',
      script_data_config_upload_desc: "These settings won't be imported: network, IP filtering, swap size",
      script_data_config_upload_doc_link: 'https://wiki.passman.co/latest/en/administrator-s-guide/padmin-system-administration/data-backup-restore',
      script_data_import_export: 'import/export settings',
      script_data_database_backup: 'backup database',
      script_data_database_backup_desc: 'Give a name to the backup. You can use alphanumeric chars and these: _ . -',
      script_data_database_backup_doc_link: 'https://wiki.passman.co/latest/en/administrator-s-guide/padmin-system-administration/data-backup-restore',
      script_data_delete_dump: 'delete backup',
      script_data_delete_dump_desc: 'Use CTRL to select multiple individual items. Use SHIFT to select range of items.',
      script_data_delete_dump_doc_link: 'https://wiki.passman.co/latest/en/administrator-s-guide/padmin-system-administration/data-backup-restore',
      script_data_import_export_doc_link: 'https://wiki.passman.co/latest/en/administrator-s-guide/padmin-system-administration/data-backup-restore/auto-backup-settings',
      script_data_database_download_doc_link: 'https://wiki.passman.co/latest/en/administrator-s-guide/padmin-system-administration/data-backup-restore',
      script_data_database_download: 'download database',
      script_data_database_readonly: 'PassMan readonly',
      script_data_database_restore: 'restore database',
      script_data_database_restore_doc_link: 'https://wiki.passman.co/latest/en/administrator-s-guide/padmin-system-administration/data-backup-restore',
      script_data_database_upload: 'upload database file',
      script_data_database_upload_desc: 'File to be uploaded must have been exported via padmin previously, file extension must be .tar.enc or .gz.enc (in case of older backups). After upload you have to restore the database manually.',
      script_data_database_upload_doc_link: 'https://wiki.passman.co/latest/en/administrator-s-guide/padmin-system-administration/data-backup-restore',
      script_data_database_writeable: 'PassMan writeable',
      script_data_export: 'export',
      script_data_guaca_control_data_upload: 'session management control data upload',
      script_data_guaca_data_upload: 'session management data upload',
      script_data_import: 'import',
      script_logs: 'logs',
      script_logs_activity: 'PassMan audit log',
      script_logs_activity_start_date: 'datetime',
      script_logs_activity_search: 'search',
      script_logs_archive_logs_download: 'download archive logs',
      script_logs_corosync: 'corosync logs',
      script_logs_database: 'database logs',
      script_logs_debug_bundle: 'debug bundle',
      script_logs_dmesg: 'dmesg logs',
      script_logs_filtered_activity: 'anonymous audit log',
      script_logs_filtered_activity_search_placeholder: 'search in action and failure code',
      script_logs_finish_debug_session: 'delete syslog',
      script_logs_finish_debug_session_desc: 'Turn off debug mode and clear syslog',
      script_logs_full_padmin_activity: 'full padmin audit log',
      script_logs_full_padmin_activity_search_placeholder: 'search in user UPN, user address and action fields',
      script_logs_own_padmin_activity: 'own padmin audit log',
      script_logs_own_padmin_activity_search_placeholder: 'search in action',
      script_logs_passman: 'PassMan logs',
      script_logs_passman_syslog: 'PassMan syslog',
      script_logs_passman_syslog_desc_cluster: "Events which happened on the other nodes won't be shown here",
      script_logs_session_management: 'session management',
      script_logs_syslog: 'syslog',
      script_revert_update: 'revert update',
      script_revert_update_revert_agung_update: 'revert passman update',
      script_revert_update_revert_padmin_update: 'revert padmin update',
      script_security: 'security settings',
      script_security_acl: 'PassMan permission settings',
      script_security_acl_desc: 'force visibility rights: automatic setting of read entity right for items above the current item in the tree, even if the user does not have necesary rights to set them',
      script_security_certificate: 'certificate',
      script_security_certificate_desc: 'Allow self signed cert in pmsl - passman communication',
      script_security_check_login_time: 'check login time',
      script_security_check_login_time_desc: 'If enabled, PassMan checks the time of the login credentials. This might cause token expiry error, if system clock is out of sync.',
      script_security_cluster_ssh_port: 'cluster ssh port',
      script_security_debug_mode: 'debug mode',
      script_security_extra_checks: 'extra security checks',
      script_security_extra_checks_desc: 'In selected cases, as an extra check, PassMan will ask for the password of the logged in user before execution. This increases security but reduces the comfortable use of the system.',
      script_security_extra_checks_param_restart_invalidates_auth_token: 'Restart invalidate auth tokens',
      script_security_forgotten_password: 'forgotten password',
      script_security_forgotten_password_desc: 'Detailed info in PassMan wiki',
      script_security_forgotten_password_param_forgotten_password_req_freq: 'Frequency of forgotten password requests (1 user with 1 e-mail address)',
      script_security_forgotten_password_param_password_change_link_validity: 'Link valid for',
      script_security_installer_debug_log_level: 'installer debug log level',
      script_security_ip_filter: 'Incoming IP filtering',
      script_security_ip_filter_applies_to: 'Applies to',
      script_security_ip_filter_confirm_desc: 'IP filter settings applied! Please check that settings are correct, and everyone has access to the PassMan server, who are entitled! If you do not confirm in the given time, changes will be reverted!',
      script_security_ip_filter_confirm_time: 'confirm time',
      script_security_ip_filter_confirm_title: 'Confirm IP filter settings',
      script_security_ip_filter_desc: 'You can configure the IP adresses who can use PassMan. If this setting is disabled then every IP address can access PassMan',
      script_security_ip_filter_doc_link: 'https://wiki.passman.co/latest/en/administrator-s-guide/padmin-system-administration/security-settings/incoming-ip-filtering',
      script_security_ip_filter_enabled: 'enabled',
      script_security_ip_filter_name: 'name',
      script_security_ip_filter_netmask: 'netmask',
      script_security_ip_filter_port: 'port',
      script_security_ip_filter_src: 'source',
      script_security_ip_filter_state_confirmed: 'confirmed',
      script_security_ip_filter_state_confirm_failed: 'confirm failed',
      script_security_ip_filter_state_not_confirmed: 'not confirmed',
      script_security_ip_filter_state_error: 'error',
      script_security_ip_filter_state_reverted: 'reverted',
      script_security_ip_filter_verdict: 'verdict',
      script_security_other_security: 'other security settings',
      script_security_other_security_param_enable_smart_login: 'smart login',
      script_security_other_security_param_enable_smart_login_desc: 'If the login failed then PassMan will try to determine the correct provider from the username and will try a login to this provider',
      script_security_other_security_param_enable_smart_login_doc_link: 'https://wiki.passman.co/latest/en/administrator-s-guide/padmin-system-administration/security-settings/other-security-settings',
      script_security_other_security_param_version_number_visible: 'versin number visible',
      script_security_other_security_param_version_number_visible_desc: 'You can set visibility of PassMan version number on login page',
      script_security_regenerate_auth_secret: 'regenerate auth secret',
      script_security_regenerate_auth_secret_desc: 'PassMan and Padmin users might need to relogin',
      script_security_remote_login: 'supplier login',
      script_security_remote_login_desc: 'enable / disable supplier login for technical support user',
      script_security_remote_login_port: 'supplier login port',
      script_services: 'maintenance',
      script_services_database_init: 'database init',
      script_services_session_management_autorepair: 'Session management auto repair',
      script_services_session_management_start: 'Session management start',
      script_services_session_management_stop: 'Session management stop',
      script_services_session_management_restart: 'Session management restart',
      script_services_passman_start: 'PassMan and database start',
      script_services_passman_stop: 'PassMan and database stop',
      script_services_passman_restart: 'PassMan and database restart',
      script_services_padmin_restart: 'padmin restart',
      script_services_reboot: 'reboot server',
      script_services_reboot_all_cluster_nodes: 'reboot all servers',
      script_services_reboot_local: 'reboot local server',
      script_services_set_agung_db_readonly: 'set agung db readonly',
      script_services_set_agung_db_writeable: 'set agung db writeable',
      script_services_shutdown: 'shutdown',
      script_services_shutdown_cluster: 'shutdown cluster',
      script_services_shutdown_local: 'shutdown local server',
      script_services_update_database_indexes: 'update database indexes',
      script_services_update_database_indexes_desc: 'Updating the indexes may take several minutes. If you want to follow the operation, please check logs / database!',
      script_services_switch_database_primary: 'switch primary database to this node',
      script_services_switch_vip: 'switch vip to this node',
      script_services_switch_vip_desc: 'Changes the VIP address to refer to this node. Vault might need to be opened on the new VIP node!',
      script_status: 'system statuses',
      script_status_cluster: 'cluster',
      script_status_database: 'database',
      script_status_database_replica: 'database replica',
      script_status_database_status_summary: 'database status summary',
      script_status_date: 'date',
      script_status_disk_space_monitoring: 'used disk space monitoring',
      script_status_docker_containers: 'docker containers',
      script_status_docker_service: 'docker service',
      script_status_free_space: 'disk space',
      script_status_memory: 'memory',
      script_status_nslookup: 'nslookup',
      script_status_ping: 'ping',
      script_status_powershell_diagnostics: 'powershell diagnostics',
      script_status_webserver: 'webserver',
      script_update: 'update',
      script_update_os_update: 'OS update',
      script_update_os_update_file_source: 'file source',
      script_update_os_update_file_source: 'file source',
      script_update_os_update_upload_file: 'selected file',
      script_update_os_update_public_file: 'selected file',
      script_update_public: 'internet',
      script_update_upload: 'upload',
      script_update_init_dockerreg_fileshare: 'init dockerreg fileshare',
      script_update_update_padmin: 'update padmin',
      script_update_update_padmin_desc: 'Updating padmin includes updating several system configuration files, so it is recommended to take a snapshot before proceeding. Connection might broke, in this case reload the page after a few minutes.',
      script_update_update_padmin_file: 'update padmin',
      script_update_update_padmin_param_file_source: 'file source',
      script_update_update_padmin_param_upload_file: 'selected file',
      script_update_update_padmin_param_public_file: 'selected file',
      script_update_update_passman_param_file_source: 'file source',
      script_update_update_passman_param_upload_file: 'selected file',
      script_update_update_passman_param_public_file: 'selected file',
      script_update_update_passman: 'update passman',
      script_update_prepare_rolling_upgrade: 'Pre-task before rolling upgrade',
      send_test_mail_title: 'send test mail',
      session_management_connect_update_hour_period: 'connect update hour period (hours)',
      session_management_debug: 'session management debug mode',
      session_management_disk_usage: 'session management disk usage',
      session_management_enabled: 'enabled',
      session_management_guaca_node_fqdn: 'Session management node fqdn',
      session_management_min_session_length: 'min. session lenght',
      session_management_node_fqdn: 'fqdn of {node_ip}',
      session_management_session_recording: 'session recording',
      session_management_status: 'session management running',
      session_management_status_short: 'running',
      session_management_status_short_cluster: 'running on this node',
      session_management_terminal_type: 'terminal type',
      shall_change_password: 'Change your password!',
      shall_change_password_message: 'Change your password for your security! Do you want to change it now?',
      shared_secret: 'otp shared secret',
      shutdown_required: 'shutdown required',
      static_routes: 'static routes',
      status_false: 'no',
      status_null: 'not accessible',
      status_true: 'yes',
      syslog_server_destinations: 'destinations',
      syslog_server_destination_error_invalid_port: 'invalid port',
      syslog_server_destination_error_name_not_unique: 'name duplication',
      syslog_server_destination_port: 'port',
      syslog_server_destination_remote_host: 'remote host',
      syslog_server_destination_send_activity_log: 'send audit log',
      syslog_server_destination_send_system_log: 'send system log',
      syslog_server_destination_transport: 'transport protocol',
      syslog_server_enabled: 'enabled',
      system_disk: 'system disk',
      system_memory: 'memory',
      system_status: 'system status',
      system_time: 'system time',
      time: 'time',
      time_based_secret: 'multifactor PIN',
      time_ntp_servers: 'NTP servers',
      time_timezone: 'timezone',
      time_status: 'status',
      token_expired: 'Your session has expired, please login again!',
      username: 'username',
      uploading: 'uploading',
      user_management_accessible_menus: 'accessible menus',
      user_management_add_user: 'new user',
      user_management_email: 'email',
      user_management_first_name: 'first name',
      user_management_last_name: 'last name',
      user_management_multifactor_required: 'multifactor login required',
      user_management_password: 'password',
      user_management_password_again: 'password (again)',
      user_management_roles: 'roles',
      user_management_username: 'username',
      vault_open: 'vault open',
      vpn_status: 'VPN status',
      vpn_status_connected: 'connected',
      vpn_status_not_configured: 'not configured',
      vpn_status_not_connected: 'not connected',
      vpn_status_not_installed: 'not installed',
      vpn_status_unknown: 'unknown',
      vpn_status_unknown_session: 'unknown session',
      will_run_on_each_cluster_node: 'will run on each cluster node',
      will_run_on_this_cluster_node_only: 'will run on this cluster node only',
      zabbix_either_passive_or_active_server: 'If zabbix is enabled either passive or active server must be set',
      zabbix_enabled: 'enabled',
      zabbix_encryption: 'encryption',
      zabbix_hostname: 'hostname',
      zabbix_leave_empty_to_generate: 'leave empty to generate',
      zabbix_listen_port: 'port (passiv servers can connect through it)',
      zabbix_mode: 'mode',
      zabbix_psk: 'psk',
      zabbix_psk_identity: 'psk identity',
      zabbix_servers_active: 'active servers',
      zabbix_servers_passive: 'passive servers'
    }
  },

  hu: {
    message: {
      about: 'padminról',
      active_users: 'active userek az elmúlt {min} percben',
      agung_runtime_errors: 'PassMan futásidejű hibák',
      agung_runtime_errors_count: 'előfordulások száma',
      agung_runtime_errors_first_occ_datetime: 'első előfordulás ideje',
      agung_runtime_errors_none: 'nincs',
      autocomplete_after_loading_ous: 'automatikus kiegészítés OU-k betöltése után',
      auth_conf_default_provider: 'alapértelmezett provider',
      auth_conf_new_ad: 'active-directory',
      auth_conf_new_atl_crowd: 'atlassian crowd',
      auth_conf_new_azure_ad: 'azure AD',
      auth_conf_new_jira_oauth2: 'Jira OAuth2',
      auth_conf_new_open_ldap: 'Open LDAP',
      auth_conf_new_oracle: 'Oracle IDCS',
      auth_conf_new_saml2: 'saml2',
      auth_conf_passman_url: 'PassMan URL',
      auth_conf_provider_ad_doc_label: 'Hogyan kell beállítani az AD-t a PassMan-hoz',
      auth_conf_provider_ad_doc_link: ' https://wiki.passman.co/latest/hu_hu/administrator-s-guide/padmin-system-administration/system-settings/authentication-provider-settings/windows-ad-provider',
      auth_conf_provider_app_token: 'app_token',
      auth_conf_provider_azure_doc_label: 'Hogyan kell beállítani az azure AD-t a passman-hoz',
      auth_conf_provider_azure_doc_link: 'https://wiki.passman.co/latest/hu_hu/administrator-s-guide/padmin-system-administration/system-settings/authentication-provider-settings/azure-ad-provider',
      auth_conf_provider_base_dn: 'base DN',
      auth_conf_provider_base_dn_placeholder: 'formátum: dc=demopassmanad,dc=local',
      auth_conf_provider_base_dn_warning: 'Első karakter nem lehet, és az utolsó karakter csak speciális esetben lehet idézőjel',
      auth_conf_provider_base_url: 'base URL',
      auth_conf_provider_certificate: 'certificate',
      auth_conf_provider_client_id: 'kliens ID',
      auth_conf_provider_credential: 'credential',
      auth_conf_provider_context: 'context',
      auth_conf_provider_error_missing_param: 'Hiányzik a {param_name} paraméter a {prov_name} esetén!',
      auth_conf_provider_groups_all: 'mind',
      auth_conf_provider_groups_none: 'egyik sem',
      auth_conf_provider_group_member_attr: 'csoporttagság attribútum',
      auth_conf_provider_group_object_class: 'csoport objektum osztály',
      auth_conf_provider_is_sso: 'SSO bejelentkezés',
      auth_conf_provider_is_sso_desc: 'Automatikus bejelentkezés, ha a felhasználó már be van jelentkezve az Azure AD-ba',
      auth_conf_provider_jira_doc_label: 'Hogyan kell beállítani az jira-t a passman-hoz',
      auth_conf_provider_jira_doc_link: 'https://wiki.passman.co/latest/hu_hu/administrator-s-guide/padmin-system-administration/system-settings/authentication-provider-settings/jira-provider',
      auth_conf_provider_name: 'név',
      auth_conf_provider_open_ldap_doc_label: 'Hogyan kell beállítani az Open LDAP-ot a passman-hoz',
      auth_conf_provider_open_ldap_doc_link: ' https://wiki.passman.co/latest/hu_hu/administrator-s-guide/padmin-system-administration/system-settings/authentication-provider-settings/open-ldap-provider',
      auth_conf_provider_port: 'port',
      auth_conf_provider_redirect_uri: 'átirányítás URI',
      auth_conf_provider_required_groups: 'authentikációs csoportok',
      auth_conf_provider_saml_auth: 'SAML auth használata',
      auth_conf_provider_saml_claims_email: 'email SAML attribute name',
      auth_conf_provider_saml_claims_first_name: 'first name SAML attribute name',
      auth_conf_provider_saml_claims_groups: 'groups SAML attribute name',
      auth_conf_provider_saml_claims_last_name: 'last name SAML attribute name',
      auth_conf_provider_saml_claims_upn: 'UPN SAML attribute name',
      auth_conf_provider_saml_doc_label: 'Hogyan kell beállítani az saml2-t a passman-hoz',
      auth_conf_provider_saml_doc_link: ' https://wiki.passman.co/latest/en/administrator-s-guide/padmin-system-administration/system-settings/authentication-provider-settings/saml2-provider',
      auth_conf_provider_saml_entity_id: 'Identity Provider Entity ID',
      auth_conf_provider_saml_lp_x509cert: 'IdP Signature certificate',
      auth_conf_provider_saml_slo: 'SSO Logout URL',
      auth_conf_provider_saml_sp_private_key: 'SP Encryption privát kulcs',
      auth_conf_provider_saml_sp_x509cert: 'SP Encryption certificate',
      auth_conf_provider_saml_sso: 'SSO Login URL',
      auth_conf_provider_servers: 'szerverek',
      auth_conf_provider_tech_user_password: 'technikai user jelszava',
      auth_conf_provider_tech_user_username: 'technikai user userneve',
      auth_conf_provider_tenant_name: 'tenant',
      auth_conf_provider_token_expiry_hours: 'token érvényességi ideje',
      auth_conf_provider_tooltip: 'A kitöltési útmutató ezen a linken érhető el',
      auth_conf_provider_used_groups: 'jogosultság csoportok',
      auth_conf_provider_username_field: 'usernév mező',
      auth_conf_provider_valid_names: 'érvényes nevek',
      auth_conf_provider_visible_ous: 'látható OU-k',
      auth_conf_provider_visible_ous_placeholder: 'formátum: SouthAmerica/Sales/Servers',
      auth_conf_token_expiry: 'bejelentkezés érvényességi ideje',
      auth_conf_token_expiry_forced: 'központi',
      auth_conf_token_expiry_forced_desc: 'Ha ez a paraméter be van kapcsolva, akkor a felhasználók nem tudják egyénileg módosítani a bejelentkezés érvényességi idejét (tokenlejáratot). Az összes felhasználónál beállításra kerül az itt meghatározott idő.',
      autorefresh_is_off: 'automatikus frissítés kikapcsolva',
      autorefresh_is_on: 'automatikus frissítés bekapcsolva',
      business_result_Failed: 'sikertelen',
      business_result_InProgress: 'folyamatban',
      business_result_InUpload: 'feltöltés alatt',
      business_result_Success: 'sikeres',
       backup: 'elment',
      button_cancel: 'mégse',
      button_check: 'ellenőrzés',
      button_close: 'bezár',
      button_confirm: 'megerősít',
      button_connect: 'kapcsolódás',
      button_copy: 'másol',
      button_copy_to_clipboard: 'másolás vágólapra',
      button_delete: 'töröl',
      button_delete_multifactor_shared_secret: 'OTP kód törlése, felhasználó bejelentkezéskor új kódot kap',
      button_disconnect: 'leválaszt',
      button_disable: 'letilt',
      button_download: 'letölt',
      button_edit: 'szerkeszt',
      button_enable: 'tiltás feloldása',
      button_existing_cluster: 'létező cluster',
      button_export: 'export',
      button_import: 'import',
      button_initialize: 'inicializál',
      button_load_group_names: 'csoportok betöltése',
      button_load_ou_names: 'OU-k betöltése',
      button_login: 'belépés',
      button_move_down: 'felfele mozgat',
      button_move_up: 'lefele mozgat',
      button_new: 'új',
      button_new_cluster: 'új klaszter',
      button_next: 'tovább',
      button_notify: 'értesít',
      button_padmin_restart: 'padmin újraindítása',
      button_passman_restart: 'PassMan újraindítása',
      button_reboot: 'újraindít',
      button_refresh: 'frissít',
      button_reload: 'oldal újratöltése',
      button_reset_password_email: 'jelszó változtatás email',
      button_restart: 'újraindít',
      button_restore: 'visszaállít',
      button_run: 'futtat',
      button_save: 'ment',
      button_send: 'küldés',
      button_show_cluster: 'klaszter mutatása',
      button_show_multifactor_shared_secret_dialog: 'OTP közös titok mutatása',
      button_show_output: 'kimenet mutatása',
      button_shutdown: 'leállítás',
      button_status: 'státusz',
      button_unstuck: 'beragadás feloldása',
      button_update: 'frissít',
      button_upload: 'feltölt',
      button_verify: 'ellenőrzés',
      button_yes: 'igen',
      change_password: 'jelszó megváltoztatása',
      change_password_cluster_sys: 'Mindegyik tagon (node) külön kell jelszót változtatni!',
      change_password_success: 'jelszó sikeresen megváltoztatva',
      update_provider_status: 'provider userek és csoportok frissítése',
      cluster_node_status_false: 'down',
      cluster_node_status_true: 'up',
      cluster_remote_login_port: 'klaszter távoli hozzáférés port',
      cluster_status: 'klaszter státusz',
      cluster_status_alive_3: 'ok',
      cluster_status_alive_2: 'ok',
      cluster_status_alive_1: 'nem ok',
      cluster_status_alive_0: 'nem ok',
      comment: 'komment',
      comp_needs_update: 'frissíteni kell!',
      confirmation_text: 'Biztos benne?',
      confirmation_title: 'Megerősítés szükséges',
      conflict: 'Konfliktus',
      conflict_message: "{user} felhasználó épp most hajt végre {action} módosítást, meg kell várni, hogy végezzen.",
      conflict_same_user_message: "Az {action} feladat még folyamatban van. Ha gyanús, hogy beragadt, akkor fel lehet oldani a Logok/Padmin audit log oldalon.",
      current_password: 'Jelenlegi jelszó',
      dashboard: 'irányítópult',
      data_export: 'export',
      data_import: 'import',
      data_import_export_auto_enabled: 'automata mentés engedélyzve',
      data_import_export_auto_interval_type: 'intervallum',
      data_import_export_auto_interval_type_daily: 'naponta',
      data_import_export_auto_interval_type_every_x_minutes: 'minden x. percben',
      data_import_export_daily_at_time: 'naponta ebben az időben',
      data_import_export_daily_at_time: 'naponta ebben az időben',
      data_import_export_decrypt_password: 'Jelszó a visszafejtéshez',
      data_import_export_encrypt_password: 'Jelszó a titkosításhoz',
      data_import_export_every_x_minutes_begin: 'minden',
      data_import_export_every_x_minutes_end: 'percben',
      data_import_export_export_destination: 'export cél',
      data_import_export_export_destination_cifs: 'szerver cifs-en keresztül',
      data_import_export_export_destination_cifs_domain: 'domén',
      data_import_export_export_destination_cifs_password: 'jelszó',
      data_import_export_export_destination_cifs_smb_server: 'smb szerver',
      data_import_export_export_destination_cifs_smb_share: 'smb megosztás',
      data_import_export_export_destination_cifs_username: 'felhasználónév',
      data_import_export_export_destination_none: 'semmi',
      data_import_export_export_destination_scp: 'szerver scp-n keresztül',
      data_import_export_export_destination_scp_auth_method: 'authentikációs metódus',
      data_import_export_export_destination_scp_directory_path: 'könyvtár elérési útvonala',
      data_import_export_export_destination_scp_password: 'jelszó',
      data_import_export_export_destination_scp_private_key: 'privát kulcs',
      data_import_export_export_destination_scp_server: 'szerver',
      data_import_export_export_destination_scp_server_port: 'port',
      data_import_export_export_destination_scp_username: 'felhasználónév',
      data_import_export_export_sm_data: 'távoli kapcsolódások adatainak exportálása',
      data_import_export_export_sm_data_desc: 'Nagy tárhely igénye miatt csak exportálás esetén',
      data_import_export_import_params: 'import paraméterek',
      data_import_export_import_param_db_file: 'adatbázis mentés file',
      data_import_export_import_param_sm_control_file: 'távoli kapcsolódások control állomány',
      data_import_export_import_param_sm_data_file: 'távoli kapcsolódások adat állomány',
      data_import_export_import_param_system_config_file: 'rendszer mentés állomány',
      data_import_export_import_source: 'import forrás',
      data_import_export_keep_for_days: 'meddig tartsa meg lokálisan',
      database_primary: 'adatbázis elsődleges node',
      database_replica_set_status: 'adatbázis replica set státusz',
      database_running: 'adatbázis fut',
      database_running_local: 'lokális adatbázis fut',
      days: 'nap',
      db_state: 'adatbázis állapota',
      db_state_readonly: 'csak olvasható',
      db_state_readonly_pending: 'csak olvashatóra vár',
      db_state_writeable: 'írható',
      disk_space_monitoring_estimated_warning: 'Szabad lemezterület várhatóan {days} nap múlva a figyelmeztetési szint alá csökken',
      disk_space_monitoring_warn_email: 'figyelmeztetés küldése erre az email címre',
      disk_space_monitoring_warning_used_percent: 'figyelmeztetési szint',
      duplicate: 'nem egyedi',
      edit_after_loading_groups: 'szerkeszthető a csoportok betöltése után',
      edit_license: 'licenc cseréje',
      edit_providers: 'providerek szerkesztése',
      edit_sm: 'szerkesztés',
      edit_sm_storage: 'tárhely növelése',
      email_body: 'üzenet',
      email_default_sender: 'alapértelmezett feladó',
      email_expiry_notifications: 'lejárati értesítések',
      email_passman_link_url: 'PassMan link URL',
      email_password: 'jelszó',
      email_recipient: 'címzett',
      email_sent_failure: 'Email küldés sikertelen',
      email_sent_success: 'Email sikeresen elküldve',
      email_server: 'levelező szerver',
      email_server_port: 'levelező szerver port',
      email_send_test: 'teszt',
      email_status: 'email státusz',
      email_status_configured: 'konfigurálva',
      email_status_last_email_sent_time: 'utolsó elküldött levél',
      email_status_last_email_sent_time_none: 'nincs',
      email_status_not_configured: 'nincs konfigurálva',
      email_status_unsent_email_count: 'el nem küldött levelek száma',
      email_subject: 'tárgy',
      email_username: 'felhasználónév',
      email_use_tls: 'TLS használata',
      error_agung_already_readonly: 'Már most is csak olvasható!',
      error_agung_already_writeable: 'Már most is írható!',
      error_agung_could_not_set_to_readonly_pending: 'Nem sikerült átteni csak olvasható állapotba!',
      error_agung_probably_not_running: 'PassMan valószínűleg nem fut!',
      error_auth_failed: 'Belépés sikertelen',
      error_bad_gateway: 'Bad Gateway, HTTP 502',
      error_cluster_duplicate: 'Klaszterben ismétlődő cím van!',
      error_cluster_not_on_same_subnet: 'Klaszter nem ugyanazon az alhálón van!',
      error_cluster_this_ip_not_included: 'Ennek a gépnek az IP-jét be kell venni a klaszter!',
      error_could_not_validate_fqdn: 'Nem sikerült ellenőrizni, hogy az FQDN megfelelő-e: {details}. El akarja menteni ennek ellenére?',
      error_empty_license: 'Üres licenc!',
      error_forbidden_char_in_param: 'Tiltott karakter a paraméterben!',
      error_init_port_not_supported: 'Nem támogatott port ! Az értéknek 1023 felett kell lennie, vagy 22',
      error_invalid_country_code: 'Érvénytelen országkód',
      error_invalid_directory_path: 'Érvénytelen elérési útvonal!',
      error_invalid_domainname: 'Érvénytelen domén név!',
      error_invalid_domain_pattern: 'Érvénytelen domén minta!',
      error_invalid_email: 'Érvénytelen email!',
      error_invalid_filename_postfix: 'Érvénytelen állománynév postfix! Csak alfanumerikus karakterek engedélyezettek!',
      error_invalid_file_format: 'Nem megfelelő állomány (vagy állománynév)!',
      error_invalid_fqdn: 'Érvénytelen fqdn, {details}!',
      error_invalid_fqdn_port: 'Érvénytelen fqdn:port, {details}!',
      error_invalid_hostname: 'Érvénytelen gépnév!',
      error_invalid_ip: 'Érvénytelen IP cím!',
      error_invalid_name: 'Érvénytelen szabálynév! Csak alfanumerikus karakterek és a space engedélyezett!',
      error_invalid_netmask: 'Érvénytelen netmask (0 és 32 között kell lennie)!',
      error_invalid_port: 'Érvénytelen port!',
      error_invalid_providername: 'Érvénytelen provider név (csak kisbetű és szám lehet benne)',
      error_invalid_psk: 'Érvénytelen psk (csak számok és betűk lehetnek benne)!',
      error_invalid_servername: 'Érvénytelen szerver név!',
      error_invalid_tech_user: 'Érvénytelen tech user!',
      error_invalid_tenantname: 'Érvénytelen tenant név!',
      error_invalid_time: 'Érvénytelen időpont!',
      error_invalid_url: 'Érvénytelen url!',
      error_invalid_username: 'Érvénytelen felhasználónév!',
      error_ip_change_in_cluster_not_supported: 'IP cím változtatás nem támogatott cluster módban!',
      error_license_cloud_in_single: 'Cloud licenc nem érvényes single módban!',
      error_license_expired: 'A licenc lejárt!',
      error_license_invalid: 'Érvénytelen licenc!',
      error_license_not_cloud: 'Licenc nem cloud módhoz van!',
      error_license_not_ha: 'HA licenc kell a cluster módhoz!',
      error_license_not_passman: 'A licenc nem Passmanhoz tartozik!',
      error_license_set_later: 'Kérem később állítsa be a licencet!',
      error_license_update_period_expired: 'Frissítés nem lehetséges, mert a licencben megadott szoftver frissítési időszak lejárt (vagy érvénytelen a licenc)!',
      error_missing: 'Hiányzó',
      error_not_enough_disk_space: 'Nincs elég szabad lemezterület! Még ennyire van szükség: ',
      error_os_update_extract: 'Nem sikerült kitömöríteni az OS update file-t',
      error_os_update_not_allowed: 'OS frissítés nem engedélyezett ebben az állapotban! Kezdje újra a telepítést új image-ből és az OS frissítést rögtön a hálózati beállítások után futassa!',
      error_password_must_contain_lowercase_letter: 'tartalmaznia kell kisbetűt',
      error_password_must_contain_number: 'tartalmaznia kell számot',
      error_password_must_contain_special_char: 'tartalmaznia kell speciális karaktert',
      error_password_must_contain_uppercase_letter: 'tartalmaznia kell nagybetűt',
      error_password_too_short: 'legalább 12 karakternek kell lennie',
      error_password_weak: 'Jelszó nem elég biztonságos!',
      error_passwords_dont_match: 'Nem azonos a két jelszó!',
      error_static_route_not_same_subnet: 'Statikus út nem ugyanazon az alhálón van!',
      error_swap_no_change: 'Nincs változás',
      error_timeout_restart_agung_remark: 'A művelet valamiért túl sokáig tart. Kérem várjon pár percet, és utána indítsa újra a PassMant!',
      error_timeout_restart_padmin_remark: 'A művelet valamiért túl sokáig tart. Kérem várjon pár percet, és utána indítsa újra a padmint!',
      error_too_many_login_attempts: 'Túl sok belépési kísérlet, kérem próbálja újra később!',
      error_update_not_allowed_before_network_set: 'Frissítés nem lehetséges a halózati paraméterek beállítása előtt!',
      error_username_empty: 'Üres usernév!',
      error_vpn_enable_autoconnect_in_connected_state_only: 'Autoconnect-et csak connected állapotban lehet bekapcsolni',
      external: 'külső',
      filename: 'állománynév',
      file_upload_browse_button: 'Tallóz',
      file_upload_placeholder: 'Válasszon ki egy állományt...',
      forbidden: 'Tiltva',
      forbidden_message: 'Nincs jogosultsága a funkció eléréséhez!',
      force_save: 'mentés mindenképp',
      forgot_password: 'Elfelejtettem a jelszót',
      downloading: 'letöltés alatt',
      hostname: "host neve",
      hours: 'óra',
      info_debug_mode_enabled: 'Debug mód bekapcsolva',
      info_debug_mode_disabled: 'Debug mód kikapcsolva',
      info_mongo_explain_disabled: 'Mongo explain kikapcsolva',
      info_mongo_explain_enabled: 'Mongo explain bekapcsolva',
      init_agung: 'adatbázis inicializálás',
      init_agung_email: 'email',
      init_agung_error_invalid_email: 'érvénytelen email cím',
      init_agung_error_min_length_16: 'legalább 16 karakter hosszúnak kell lennie',
      init_agung_first_name: 'keresztnév',
      init_agung_generate: 'kezdeti paraméterek generálása',
      init_agung_last_name: 'vezetéknév',
      init_agung_password: 'lokális felhasználó jelszava',
      init_agung_username: 'lokális felhasználó neve',
      init_agung_vault_password: 'széf felhasználó jelszava',
      init_agung_vault_username: 'széf felhasználó neve',
      init_agung_passwords_warning: 'A vault és admin jelszót fel kell jegyezni, mert többet nem lesz látható.',
      init_cluster_info: 'Ebben a sorrendben kell a node-okat installálni, és ez a node legyen az első!',
      init_cluster_ip: 'klaszter IP',
      init_cluster_nodes: 'klaszter tagok',
      init_cluster_warning: 'A klaszter összes tagját be kell állítani, mielőtt az adatbázist inicializálni lehetne',
      init_join_cluster_node_ip: 'egészséges kluszter node IP címe',
      init_hint_mode_first: 'Először a módot kell beállítítani',
      init_hint_license_first: 'Először a licencet kell beállítani!',
      init_hint_network_first: 'Először a hálózatot kell beállítani!',
      init_hint_mode_first: 'Először a módot kell beállítani!',
      init_mode: 'mód',
      init_node_ip: 'tag IP címe',
      init_mode_new_cluster_warning: 'Kérjük ellenőrizze, hogy a cluster beállítások helyesek! Mentés után már nem lehet változtatni.',
      init_procedure: 'inicializálási folyamat',
      init_state: 'inicializásás állapota',
      init_success: 'inicializáció sikeres',
      instance_state: 'cloud instance állapota',
      ip_address: 'IP cím',
      ip_change_redirect_title: 'Átirányítás az új IP címre',
      ip_change_redirect_desc: 'IP cím változás miatt át kell irányítani az új IP címre',
      license_account_count: 'felhasználói fiókok száma',
      license_company: 'előfizető',
      license_current: 'jelenlegi licenc',
      license_expiry: 'licenclejárat',
      license_user_count: 'felhasználók száma',
      license_new: 'új licenc beírása',
      license_new_file: 'új licenc állomány',
      license_session_management_active_session_count: 'aktív kapcsolatok száma',
      license_session_management_session_count: 'kapcsolatok száma',
      license_session_management_support: 'távoli kapcsolódások',
      license_software_update_till: 'software frissítés eddig',
      license_status: 'licenc státusza',
      license_status_expired: 'lejárt',
      license_status_invalid: 'érvénytelen',
      license_status_valid: 'érvényes',
      license_target_count: 'eszközök száma',
      language: 'nyelv',
      language_de: 'német',
      language_en: 'angol',
      language_hu: 'magyar',
      last_boot_time: 'utolsó újraindítás',
      last_db_dump_time: 'utolsó adatbázis mentés',
      last_db_dump_time_none: 'nincs',
      last_login_time: 'utolsó belépés',
      last_open_time: 'utolsó nyitás',
      last_refresh: 'utoljára frissítve',
      last_update: 'utolsó frissítés',
      last_update_details: 'részletek',
      last_update_params: 'ezekkel a paraméterekkel',
      last_update_system_time: 'rendszer idő',
      load_balancer_used: 'load balancer aktív',
      load_balancer_fqdn: 'load balancer fqdn-je',
      local: 'lokális',
      login: 'belépés',
      logout: 'kilépés',
      minutes: 'perc',
      multifactor_qr_text: 'sgsgsgsg',
      network: 'hálózati beállítások',
      network_dns: 'dns',
      network_gateway: 'gateway',
      network_netmask: 'netmask',
      network_search_domains: 'keresési domainek',
      network_search_domains_info: 'lokális dns esetén ajánlott beállítani',
      network_static_ip: 'statikus IP cím',
      network_static_route_metric: 'metric',
      network_static_route_to: 'to',
      network_static_route_via: 'via',
      new_password: 'új jelszó',
      new_password_again: 'új jelszó mégegyszer',
      no_change: '**********',
      none_or_no_change: '**********',
      notified_count: '{notified_count} user kapott értesítést',
      notify_failed_count: 'Nem sikerült értesíteni {failed_count} usert',
      notify_failure: 'Nem sikerült értesíteni egyetlen usert sem',
      notify_success: 'Aktív userek sikeresen értesítve',
      open_vault: 'széf nyitása',
      optional: 'opcionális',
      os_update: 'OS frissítés',
      output: 'Eredmény',
      page_reload_title: 'Oldal újratöltése',
      page_reload_desc: 'Újra kell tölteni az oldalt néhány másodperc múlva, hogy a változások érvényre jussanak',
      page_reload_reboot_title: 'Oldal újratöltése pár perc elteltével',
      page_reload_reboot_desc: 'Újra kell tölteni az oldalt, hogy a változások érvényre jussanak. Az újraindítás pár percig eltarthat, ez alatt a időalatt nem lesz válasz.',
      padmin_restart_required: 'Padmin újraindítás szükségeltetik',
      padmin_and_passman_restart_required: 'Padmin és PassMan újraindítás szükséges',
      passman_accessible: 'PassMan elérhető',
      passman_restart_required: 'PassMan újraindítás szükséges',
      passman_running: 'PassMan fut',
      passman_running_local: 'lokális passman fut',
      passman_status: 'PassMan státusz',
      password: 'jelszó',
      password_changed: 'Jelszó sikeresen megváltoztatva.',
      password_changed_on_this_node_only: 'Jelszó sikeresen megváltoztatva csak ezen a node-on.',
      password_changed_on_all_nodes: 'Jelszó sikeresen megváltoztatva mindegyik a node-on.',
      password_expired_message: 'Lejárt a jelszó, meg kell változtatni.',
      passwords_dont_match: 'Jelszavak nem egyeznek meg.',
      pmsl_command_demo: "PMSL parancs demo",
      pmsl_command_demo_account_name: "felhasználói fiók",
      pmsl_command_demo_check: "futtat",
      pmsl_command_demo_client: "kliens",
      pmsl_command_demo_command: "parancs",
      pmsl_command_demo_credential_type: "titok típusa",
      pmsl_command_demo_explicit_localhost: "explicit localhost",
      pmsl_command_demo_gateway_auth_enabled: "gateway authentikáció bekapcsolva",
      pmsl_command_demo_network_level_auth: "hálózati szintű authentikáció",
      pmsl_command_demo_send_gateway_token: "token küldése a gatewaynek (use token)",
      pmsl_command_demo_target_name: "eszköz neve",
      pmsl_command_demo_target_type: "eszköz típusa",
      pmsl_command_demo_through_gateway: "gatewayen keresztül (proxy)",
      pmsl_command_demo_use_scb: "scb bekapcsolva (use scb)",
      proc: 'folyamatok',
      provider_check_error: "Nem sikerült kapcsolódni",
      provider_check_success: "A kapcsolódás sikeres volt!",
      provider_check_invalid_groups: "Ezek a csoportok érvénytelennek tűnnek",
      pwd_info_title: 'A beírt jelszó',
      pwd_info_line1: 'Nem lehet 8 karakternél rövidebb',
      pwd_info_line2: 'Legyen benne kis- és nagybetű',
      pwd_info_line3: 'Tartalmazzon számot és speciális karaktert',
      pwd_info_line4: 'Monotonikus szekvencia ismétlés szám max.3',
      pwd_info_line5: 'Előző jelszóból max. 5 karaktert tartalmazhat',
      pwd_info_line6: 'A felhasználónév nem lehet benne',
      reboot_text: 'A szerver újraindul, ez eltarthat egy darabig. Kérem frissítse az oldalt pár perc múlva!',
      reboot_local_title: 'Lokális gép újraindítása',
      reboot_local_desc: 'Újra kell indítani a gépet az inicializálás befejezéséhez',
      remote_login_port: 'távoli hozzáférés port',
      required: 'szükséges',
      request_address: 'Az ön IP címe',
      request_route: 'Ezen az útvonalon keresztül',
      reset_password_email_info: 'Email a jelszóváltoztatáshoz szükséges instrukciókkal elküldve (amennyiben létezik ez a usernév, és meg van adva az email címe)',
      result_failure: 'sikertelen',
      result_in_progress: 'futtatás alatt',
      result_success: 'sikeres',
      run_auto_backup_test: 'próba futtatás',
      running_task_count: 'épp futó feladatok száma',
      script_certificate: 'tanúsítvány',
      script_certificate_generate_self_signed_cert: 'self signed tanúsítvány generálás',
      script_certificate_cert_request: 'tanúsítvány kérelem',
      script_certificate_upload_cert: 'tanúsítvány feltöltése',
      script_config: 'rendszerbeállítások',
      script_config_authentication: 'autentikálás',
      script_config_authentication_doc_link: ' https://wiki.passman.co/latest/hu_hu/administrator-s-guide/padmin-system-administration/system-settings/authentication-provider-settings',
      script_config_authentication_short: 'autentikálás',
      script_config_auto_jobs: 'automatikus feladatok',
      script_config_auto_jobs_desc: 'A PassMan a háttérben is futtat napi feladatokat. Itt be lehet állítani, hogy a nap mely órájában fussanak, lehetőleg éjszaka, amikor kevesebben használják a rendszert. Az időbeli sorrend is lehetőleg az legyen, mint itt a megjelenítés. Érdemes először ellenőrizni a jelszavak státuszát, aztán a lejárókat lecserélni, majd a később lejárókról email értesítőt küldeni.',
      script_config_auto_jobs_doc_link: 'https://wiki.passman.co/latest/hu_hu/administrator-s-guide/padmin-system-administration/system-settings/auto-jobs',
      script_config_email: 'emailfiók beállítása',
      script_config_email_doc_link: 'https://wiki.passman.co/latest/hu_hu/administrator-s-guide/padmin-system-administration/system-settings/email-account-settings',
      script_config_extend_volume: 'Kötetméret növelése',
      script_config_extend_volume_desc: 'Először a virtualizacios layerben (vmware, hyper-v, proxmox) kell megnövelni a diszket!',
      script_config_extend_volume_doc_link: 'https://wiki.passman.co/latest/hu_hu/administrator-s-guide/padmin-system-administration/system-settings/volume-size-expanding',
      script_config_license: 'licenc',
      script_config_network: 'hálózati beállítások',
      script_config_network_doc_link: 'https://wiki.passman.co/latest/hu_hu/administrator-s-guide/padmin-system-administration/system-settings/network-settings',
      script_config_nginx_file_upload_size: 'Max. file méret feltöltésnél',
      script_config_passman_service: 'passman szerviz',
      script_config_push_notification: 'push notification',
      script_config_pmsl: 'PMSL beállítások',
      script_config_pmsl_desc: 'Ezek a beállítások befolyásolják hogy a pmsl tool hogyan kapcsolódik az eszközhöz a passmanból kezdeményezett kapcsolódás hatására (1 klikk). Explicit localhost: hozzáteszi a ./-t az eszköznév elejére.',
      script_config_secret: 'secret',
      script_config_session_management: 'Távoli kapcsolódások',
      script_config_session_management_doc_link: 'https://wiki.passman.co/latest/hu_hu/administrator-s-guide/padmin-system-administration/system-settings/session-management-settings',
      script_config_supported_languages: 'támogatott nyelvek',
      script_config_swap: 'swap',
      script_config_syslog_server: 'syslog szerver',
      script_config_time: 'idő és NTP szerverek',
      script_config_time_doc_link: 'https://wiki.passman.co/latest/hu_hu/administrator-s-guide/padmin-system-administration/system-settings/time-and-ntp-servers',
      script_config_user_management: 'felhasználók kezelése',
      script_config_vpn_connection: 'VPN kapcsolat',
      script_config_vpn_connection_doc_link: 'https://wiki.passman.co/latest/hu_hu/administrator-s-guide/padmin-system-administration/system-settings/vpn-connection',
      script_config_vpn_connection_autoconnect: 'automatikus kapcsolódás',
      script_config_vpn_connection_password: 'jelszó',
      script_config_vpn_connection_vpn_profile: 'VPN profil',
      script_config_vpn_connection_type: 'kapcsolat',
      script_config_vpn_connection_username: 'felhasználónév',
      script_config_workflow: 'Igénylés-Engedélyezés modul',
      script_config_zabbix: 'Zabbix',
      script_data: 'adat mentés/visszaállítás',
      script_data_config_download: 'rendszerbeállítások letöltése',
      script_data_config_download_doc_link: 'https://wiki.passman.co/latest/hu_hu/administrator-s-guide/padmin-system-administration/data-backup-restore',
      script_data_config_upload: 'rendszerbeállítások feltöltése',
      script_data_config_upload_desc: "Ezek a beállítások nem lesznek importálva: hálózaz, IP cím szűrés, swap méret",
      script_data_config_upload_doc_link: 'https://wiki.passman.co/latest/hu_hu/administrator-s-guide/padmin-system-administration/data-backup-restore',
      script_data_import_export: 'import/export beállítások',
      script_data_import_export_doc_link: 'https://wiki.passman.co/latest/hu_hu/administrator-s-guide/padmin-system-administration/data-backup-restore/auto-backup-settings',
      script_data_database_backup: 'adatbázis biztonsági mentése',
      script_data_database_backup_desc: 'Adjon nevet a mentésnek! Alfanumerikus karakterek és _ . - engedélyezettek.',
      script_data_database_backup_doc_link: 'https://wiki.passman.co/latest/hu_hu/administrator-s-guide/padmin-system-administration/data-backup-restore',
      script_data_delete_dump: 'biztonsági mentés törlése',
      script_data_delete_dump_desc: 'CTRL-al több elemet is ki lehet választani, SHIFT-el tartományt lehet kiválasztani.',
      script_data_delete_dump_doc_link: 'https://wiki.passman.co/latest/hu_hu/administrator-s-guide/padmin-system-administration/data-backup-restore',
      script_data_database_download: 'adatbázis file letöltése',
      script_data_database_download_doc_link: 'https://wiki.passman.co/latest/hu_hu/administrator-s-guide/padmin-system-administration/data-backup-restore',
      script_data_database_readonly: 'PassMan csak olvasható',
      script_data_database_restore: 'adatbázis visszaállítása',
      script_data_database_restore_doc_link: 'https://wiki.passman.co/latest/hu_hu/administrator-s-guide/padmin-system-administration/data-backup-restore',
      script_data_database_upload: 'adatbázis file feltöltése',
      script_data_database_upload_desc: 'Csak padmin-on keresztül letöltött file-t lehet importálni, file kiterjesztésének .tar.enc vagy .gz.enc (régebbi mentéseknél) kell legyen. Feltöltés után a visszaállítást manuálisan kell lefuttatni.',
      script_data_database_upload_doc_link: 'https://wiki.passman.co/latest/hu_hu/administrator-s-guide/padmin-system-administration/data-backup-restore',
      script_data_database_writeable: 'PassMan írható',
      script_data_export: 'export',
      script_data_guaca_control_data_upload: 'session management kontroll adatok feltöltése',
      script_data_guaca_data_upload: 'session management adatok feltöltése',
      script_data_import: 'import',
      script_logs: 'logok',
      script_logs_activity: 'PassMan audit log',
      script_logs_activity_start_date: 'dátum',
      script_logs_activity_search: 'keresés',
      script_logs_archive_logs_download: 'archív logok letöltése',
      script_logs_corosync: 'corosync logok',
      script_logs_database: 'adatbázis logok',
      script_logs_debug_bundle: 'debug bundle',
      script_logs_dmesg: 'dmesg logok',
      script_logs_filtered_activity: 'anonymous audit log',
      script_logs_filtered_activity_activity_placeholder: 'keresés az action és a failure code mezőkben',
      script_logs_finish_debug_session: 'Syslog törlése',
      script_logs_finish_debug_session_desc: 'Kikapcsolja a debug módot és törli a syslog-ot',
      script_logs_full_padmin_activity: 'full padmin audit log',
      script_logs_full_padmin_activity_search_placeholder: 'keresés a user UPN, user address és action mezőkben',
      script_logs_own_padmin_activity: 'saját padmin audit log',
      script_logs_own_padmin_activity_search_placeholder: 'keresés az action mezőben',
      script_logs_passman: 'PassMan logok',
      script_logs_passman_syslog: 'PassMan syslog',
      script_logs_passman_syslog_desc_cluster: "A másik két node-on történtek itt nem jelennek meg",
      script_logs_session_management: 'session management',
      script_logs_syslog: 'syslog',
      script_revert_update: 'frissítés visszavonása',
      script_revert_update_revert_agung_update: 'PassMan frissítés visszavonása',
      script_revert_update_revert_padmin_update: 'padmin frissítés visszavonása',
      script_security: 'biztonság',
      script_security_acl: 'Passman jogosultság beállítások',
      script_security_acl_desc: 'Láthatósági jogok automatikus beállítása: az aktuális elem feletti elemek esetében Elem olvasási jog automatikus beállítása a fában, akkor is ha az adott usernek nincs beállítási joga.',
      script_security_certificate: 'tanúsítvány',
      script_security_certificate_desc: 'Self signed tanúsítvány engedélyezése a pmsl - agung kommunikációban',
      script_security_check_login_time: 'belépési idő ellenőrzése',
      script_security_check_login_time_desc: 'Ha be van kapcsolva, akkor belépéskor a PassMan ellenőrzi az időt. Ez token lejárati hibát okozhat, ha a rendszeróra nincs szinkronban.',
      script_security_cluster_ssh_port: 'cluster ssh port',
      script_security_debug_mode: 'debug mód',
      script_security_extra_checks: 'Plusz biztonsági ellenőrzések',
      script_security_extra_checks_desc: 'A kiválasztott esetekben extra ellenőrzésként a végrehajtás előtt a PassMan bekéri a belépett felhasználó jelszavát. Ez növeli a biztonságot, de csökkenti a rendszer kényelmes használatát. ',
      script_security_extra_checks_param_allow_self_signed_cert: '"saját aláírásos" tanúsítvány engedélyezése',
      script_security_extra_checks_param_restart_invalidates_auth_token: 'újraindítás érvényteleníti a bejelentkezési tokeneket',
      script_security_extra_checks_param_security_check_for_checkout: 'biztonsági ellenőrzés jelszó kikérésnél',
      script_security_extra_checks_param_security_check_for_permissions: 'biztonsági ellenőrzés a hozzáférési beállításoknál',
      script_security_extra_checks_param_security_check_for_user_management: 'biztonsági ellenőrzés a felhasználók adminisztrálásánál',
      script_security_forgotten_password: 'elfelejtett jelszó',
      script_security_forgotten_password_desc: 'Részletek a PassMan wikiben',
      script_security_forgotten_password_param_forgotten_password_req_freq: 'Elfelejtett jelszókérések gyakorisága (egy user egy email cím)',
      script_security_forgotten_password_param_password_change_link_validity: 'Elfelejtett jelszókérés link érvényessége',
      script_security_installer_debug_log_level: 'installer debug log level',
      script_security_ip_filter: 'Bejövő IP cím szűrés',
      script_security_ip_filter_applies_to: 'Érvényes',
      script_security_ip_filter_confirm_desc: 'IP cím szűrés változtatások aktiválva! Kérem ellenőrizze, hogy a beállítások helyesek, és mindenki eléri a PassMan-t, akinek kell! Ha nem erősíti meg az adott időn belül, akkor a változtatások visszavonásra kerülnek!',
      script_security_ip_filter_confirm_time: 'megerősítés ideje',
      script_security_ip_filter_confirm_title: 'IP cím szűrés beállítások megerősítése',
      script_security_ip_filter_desc: 'It lehet beállítani, hogy mely IP címekről lehessen a PassMant elérni. Ha a funkció ki van kapcsolva, akkor minden IP címről el lehet érni a Passman-t.',
      script_security_ip_filter_doc_link: ' https://wiki.passman.co/latest/hu_hu/administrator-s-guide/padmin-system-administration/security-settings/incoming-ip-filtering',
      script_security_ip_filter_enabled: 'bekapcsolva',
      script_security_ip_filter_name: 'név',
      script_security_ip_filter_netmask: 'netmask',
      script_security_ip_filter_port: 'port',
      script_security_ip_filter_src: 'tartomány',
      script_security_ip_filter_state_confirmed: 'megerősítve',
      script_security_ip_filter_state_confirm_failed: 'megerősítés sikertelen',
      script_security_ip_filter_state_not_confirmed: 'nincs megerősítve',
      script_security_ip_filter_state_error: 'hiba',
      script_security_ip_filter_state_reverted: 'visszaállítva',
      script_security_ip_filter_verdict: 'verdikt',
      script_security_other_security: 'más biztonsági beállítások',
      script_security_other_security_param_enable_smart_login: 'okos belépés',
      script_security_other_security_param_enable_smart_login_desc: 'Ha nem sikerül a belépés a megadott adatokkal, akkor a usernévből megpróbáljuk meghatározni, hogy melyik szolgáltatóhoz akart belépni a felhasználó, és ott is megpróbálunk belépni a megadott paraméterekkel',
      script_security_other_security_param_enable_smart_login_doc_link: 'https://wiki.passman.co/latest/hu_hu/administrator-s-guide/padmin-system-administration/security-settings/other-security-settings',
      script_security_other_security_param_version_number_visible: 'verziószám láthatóság',
      script_security_other_security_param_version_number_visible_desc: 'Be lehet állítani, hogy a bejelentkező ablakon megjelenjen-e a Passman verziószám',
      script_security_regenerate_auth_secret: 'auth secret újragenerálása',
      script_security_regenerate_auth_secret_desc: 'PassMan és Padmin felhasználóknak lehet, hogy újra be kell jelentkezni',
      script_security_remote_login: 'távoli hozzáférés',
      script_security_remote_login_desc: 'Technikai felhasználó távoli hozzáférésének engedélyezése / tiltása',
      script_security_remote_port: 'távoli hozzáférés port',
      script_services: 'üzemeltetés',
      script_services_database_init: 'adatbázis inicializálás',
      script_services_session_management_autorepair: 'Session management automatikus javítása',
      script_services_session_management_start: 'Session management indítása',
      script_services_session_management_stop: 'Session management leállítása',
      script_services_session_management_restart: 'Session management újraindítása',
      script_services_passman_start: 'PassMan és adatbázis indítása',
      script_services_passman_stop: 'PassMan és adatbázis leállítása',
      script_services_passman_restart: 'PassMan és adatbázis újraindítása',
      script_services_padmin_restart: 'Padmin újraindítása',
      script_services_reboot: 'szerver újraindítása',
      script_services_reboot_all_cluster_nodes: 'mindegyik szerver úraindítása',
      script_services_reboot_local: 'lokális szerver újraindítása',
      script_services_set_agung_db_readonly: 'adatbázis csak olvashatóra állítása',
      script_services_set_agung_db_writeable: 'adatbázis írhatóvá tétele',
      script_services_shutdown: 'leállítás',
      script_services_shutdown_cluster: 'cluster leállítása',
      script_services_shutdown_local: 'lokális szerver leállítása',
      script_services_update_database_indexes: 'adatbázis indexek frissítése',
      script_services_update_database_indexes_desc: 'A művelet több percig is eltarthat. A folyamat futását a Logok / Adatbázis menüpontban lehet nyomon követni.',
      script_services_switch_database_primary: 'elsődleges adatbázis átálítása erre a node-ra',
      script_services_switch_vip: 'vip átálítása erre a node-ra',
      script_services_switch_vip_desc: 'A cluster VIP címe erre a node-ra fog hivatkozni. A széfet lehet, hogy ki kell nyitni az új VIP node-on!',
      script_status: 'rendszerstátuszok',
      script_status_cluster: 'cluster',
      script_status_database: 'adatbázis',
      script_status_database_replica: 'adatbázis replika',
      script_status_database_status_summary: 'adatbázis státusz összegzés',
      script_status_date: 'dátum',
      script_status_disk_space_monitoring: 'használt lemezterület felügyelete',
      script_status_docker_containers: 'docker konténerek',
      script_status_docker_service: 'docker szerviz',
      script_status_free_space: 'szabad hely',
      script_status_memory: 'memória',
      script_status_nslookup: 'nslookup',
      script_status_ping: 'ping',
      script_status_powershell_diagnostics: 'powershell diagnosztika',
      script_status_webserver: 'webszerver',
      script_update: 'frissítés',
      script_update_os_update: 'OS frissítés',
      script_update_os_update_file_source: 'file forrása',
      script_update_os_update_upload_file: 'kiválasztott file',
      script_update_os_update_public_file: 'kiválasztott file',
      script_update_public: 'internet',
      script_update_upload: 'feltöltés',
      script_update_init_dockerreg_fileshare: 'dockerreg fileshare inicializálás',
      script_update_update_padmin: 'Padmin frissítés',
      script_update_update_padmin_desc: 'Padmin update során a system konfiguráció is frissítésre kerülhet. Ezért ajánlot előtt snapshot-ot készíteni a virtualis gépről. Ha az update folyamán megszakad a kapcsolat, akkor ajánlott  pár perc után újratölteni az oldalt.',
      script_update_update_padmin_file: 'Padmin frissítés',
      script_update_update_padmin_param_file_source: 'file forrása',
      script_update_update_padmin_param_upload_file: 'kiválasztott file',
      script_update_update_padmin_param_public_file: 'kiválasztott file',
      script_update_update_passman: 'PassMan frissítés',
      script_update_update_passman_param_file_source: 'file forrása',
      script_update_update_passman_param_upload_file: 'kiválasztott file',
      script_update_update_passman_param_public_file: 'kiválasztott file',
      script_update_prepare_rolling_upgrade: 'Rolling upgrade előkészítése',
      send_test_mail_title: 'teszt levél küldése',
      session_management_connect_update_hour_period: 'kapcsolat frissítési periódus (óra)',
      session_management_debug: 'távoli kapcsolódások debug mód',
      session_management_disk_usage: 'távoli kapcsolódások tárhely',
      session_management_enabled: 'bekapcsolva',
      session_management_guaca_node_fqdn: 'távoli kapcsolódások node fqdn-je',
      session_management_min_session_length: 'távoli kapcsolódások min. hossza',
      session_management_node_fqdn: '{node_ip} fqdn-je',
      session_management_session_recording: 'session felvétel',
      session_management_status: 'távoli kapcsolódások fut',
      session_management_status_short: 'fut',
      session_management_status_short_cluster: 'ezen a node-on fut',
      session_management_terminal_type: 'terminál típusa',
      shall_change_password: 'Változtasd meg a jelszót!',
      shall_change_password_message: 'A biztonságod érdekében változtass jelszót! Megváltoztatod most?',
      shared_secret: 'otp közös titok',
      shutdown_required: 'leállítás szükséges',
      static_routes: 'statikus útvonalak',
      status_false: 'nem',
      status_null: 'nem elérhető',
      status_true: 'igen',
      syslog_server_destinations: 'destinations',
      syslog_server_destination_error_invalid_port: 'érvénytelen port',
      syslog_server_destination_error_name_not_unique: 'név nem ismétlődhet',
      syslog_server_destination_port: 'port',
      syslog_server_destination_remote_host: 'host',
      syslog_server_destination_send_activity_log: 'audit log küldése',
      syslog_server_destination_send_system_log: 'rendszer log küldése',
      syslog_server_destination_transport: 'protokoll',
      syslog_server_enabled: 'bekapcsolva',
      system_disk: 'rendszer lemezterület',
      system_memory: 'memória',
      system_status: 'rendszerállapot',
      system_time: 'rendszeridő',
      time: 'idő',
      time_based_secret: 'multifaktor kód',
      time_ntp_servers: 'NTP szerverek',
      time_status: 'státusz',
      time_timezone: 'időzóna',
      token_expired: 'A bejelentkezésed érvényessége lejárt, kérem lépj be újra!',
      username: 'felhasználónév',
      uploading: 'feltöltés alatt',
      user_management_accessible_menus: 'elérhető menük',
      user_management_add_user: 'új felhasználó',
      user_management_email: 'email',
      user_management_first_name: 'keresztnév',
      user_management_last_name: 'családi név',
      user_management_multifactor_required: 'multifaktor-os belépés szükséges',
      user_management_password: 'jelszó',
      user_management_password_again: 'jelszó (újra)',
      user_management_roles: 'szerepkörök',
      user_management_username: 'felhasználó név',
      vault_open: 'széf nyitva',
      vpn_status: 'VPN státusz',
      vpn_status_connected: 'kapcsolódva',
      vpn_status_not_configured: 'nincs konfigurálva',
      vpn_status_not_connected: 'szétkapcsolva',
      vpn_status_not_installed: 'nincs telepítve',
      vpn_status_unknown: 'ismeretlen',
      vpn_status_unknown_session: 'ismeretlen session',
      will_run_on_each_cluster_node: 'cluster mindegyik node-ján le fog futni',
      will_run_on_this_cluster_node_only: 'cluster csak ezen node-ján fog futni',
      zabbix_either_passive_or_active_server: 'Ha a zabbix be van kapcsolva, akkor legalább egy aktív vagy passzív szervert be kell állítani',
      zabbix_enabled: 'bekapcsolva',
      zabbix_encryption: 'titkosítás',
      zabbix_hostname: 'host neve',
      zabbix_leave_empty_to_generate: 'ha üres, akkor generálni fog',
      zabbix_listen_port: 'port (passzív szerverek ezen kapcsolódhatnak)',
      zabbix_mode: 'mód',
      zabbix_psk: 'psk',
      zabbix_psk_identity: 'psk azonosító',
      zabbix_servers_active: 'aktív szerverek',
      zabbix_servers_passive: 'passzív szerverek',
    }
  }
}
